export class IntakeStatusService {
  private _completedIntake: boolean;

  constructor() {
    this._completedIntake = false;
  }

  update(status: boolean): void {
    this._completedIntake = status;
  }

  get hasCompletedIntake(): boolean {
    return this._completedIntake;
  }

  get hasNotCompletedIntake(): boolean {
    return !this._completedIntake;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/intake_status_service.ts